export const actions = {
  ETIQUETA_COMIDA_LOAD_REQUESTED: 'ETIQUETA_COMIDA_LOAD_REQUESTED',
  ETIQUETA_COMIDA_LOAD_SUCCEEDED: 'ETIQUETA_COMIDA_LOAD_SUCCEEDED',
  ETIQUETA_COMIDA_LOAD_FAILED: 'ETIQUETA_COMIDA_LOAD_FAILED',

  ETIQUETA_COMIDA_INSERT_REQUESTED: 'ETIQUETA_COMIDA_INSERT_REQUESTED',
  ETIQUETA_COMIDA_INSERT_SUCCEEDED: 'ETIQUETA_COMIDA_INSERT_SUCCEEDED',
  ETIQUETA_COMIDA_INSERT_FAILED: 'ETIQUETA_COMIDA_INSERT_FAILED',

  ETIQUETA_COMIDA_UPDATE_REQUESTED: 'ETIQUETA_COMIDA_UPDATE_REQUESTED',
  ETIQUETA_COMIDA_UPDATE_SUCCEEDED: 'ETIQUETA_COMIDA_UPDATE_SUCCEEDED',
  ETIQUETA_COMIDA_UPDATE_FAILED: 'ETIQUETA_COMIDA_UPDATE_FAILED',

  ETIQUETA_COMIDA_DELETE_REQUESTED: 'ETIQUETA_COMIDA_DELETE_REQUESTED',
  ETIQUETA_COMIDA_DELETE_SUCCEEDED: 'ETIQUETA_COMIDA_DELETE_SUCCEEDED',
  ETIQUETA_COMIDA_DELETE_FAILED: 'ETIQUETA_COMIDA_DELETE_FAILED',
}

export const getEtiquetasComidasAction = (dispatch, payload) => {
  dispatch({
    type: actions.ETIQUETA_COMIDA_LOAD_REQUESTED,
    payload,
  })
}

export const setEtiquetasComidasAction = (dispatch, payload) => {
  dispatch({
    type: actions.ETIQUETA_COMIDA_INSERT_REQUESTED,
    payload,
  })
}

export const updateEtiquetasComidasAction = (dispatch, payload) => {
  dispatch({
    type: actions.ETIQUETA_COMIDA_UPDATE_REQUESTED,
    payload,
  })
}

export const deleteEtiquetasComidasAction = (dispatch, id) => {
  dispatch({
    type: actions.ETIQUETA_COMIDA_DELETE_REQUESTED,
    id,
  })
}
